
export const timeStampFormat = "YYYY-MM-DD HH:mm:ss";

export const defaultCarouselTemplateGroupObj = {
    carousel_template_group_id: '',
    channel_id: 0,
    max_card_count: 2,
    created_at: '',
    carousel_template_group_name: '',
    meta_integration_whatsapp_id: 0,
    channel_name: '',
    waba_id: '',
    waba_name: '',
    templates: []
}